// api/userApi.ts
import client from './client';
import type {FeedUser, Gallery, Read, Work} from '~/types/types';
export interface FeedRespone {
    works: Work[];
    reads: Read[];
    talents: FeedUser[];
}
export const fetchWork = async (token: string, id: string): Promise<Work> => {
    try {
        const response = await client.get<Work>(`/works/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const fetchGallery = async (token: string, id: string): Promise<Gallery> => {
    try {
        const response = await client.get<Gallery>(`/gallery/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const fetchWorks = async (query = {}): Promise<Work[]> => {
    try {
        const response = await client.get<Work[]>('/works', {params: query});
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};
export const fetchHome = async (query = {}): Promise<Work[]> => {
    try {
        const response = await client.get<Work[]>('/works/home', {params: query});
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};
export const fetchBrandFeed = async (query = {}, token: string): Promise<FeedRespone> => {
    try {
        const response = await client.get<FeedRespone>('/feed', {
            params: query,
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const fetchSearchFeed = async (query = {}, token: string): Promise<FeedRespone> => {
    try {
        const response = await client.get<FeedRespone>('/feed/search', {
            params: query,
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const fetchPreview = async (query = {}): Promise<FeedRespone> => {
    try {
        const response = await client.get<FeedRespone>('/feed/preview', {
            params: query
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const fetchUserWorks = async (query = {}, token: string): Promise<Work[]> => {
    try {
        const response = await client.get<Work[]>('/works/user', {
            params: query,
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const fetchOtherUserWorks = async (query = {}, token: string): Promise<Work[]> => {
    try {
        const response = await client.get<Work[]>('/works/profile', {
            params: query,
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const fetchUserGalleries = async (token: string): Promise<Gallery[]> => {
    try {
        const response = await client.get<Gallery[]>('/gallery/user', {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const postWork = async (payload: any, token: string): Promise<Work> => {
    try {
        const response = await client.post<Work>('/works', payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};


export const updateWork = async (payload: any, id: string, token: string): Promise<Work> => {
    try {
        const response = await client.patch<Work>(`/works/${id}`, payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const removeWork = async (id: string, token: string): Promise<Work> => {
    try {
        const response = await client.delete<Work>(`/works/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const removeGallery = async (id: string, token: string): Promise<Gallery> => {
    try {
        const response = await client.delete<Gallery>(`/gallery/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const updateGallery = async (payload: any, id: string, token: string): Promise<Gallery> => {
    try {
        const response = await client.patch<Gallery>(`/gallery/${id}`, payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};
export const postGallery = async (payload: any, token: string): Promise<Gallery> => {
    try {
        const response = await client.post<Gallery>('/gallery', payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};


export const updateWorkOrders = async (payload: any, token: string): Promise<any> => {
    try {
        const response = await client.patch<any>('/works/order/change', payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting tag:', error);
        throw error;
    }
};